export enum ProposalActor {
  WORKER = 'FW',
  OG = 'OG',
  HQ = 'HQ',
  EXTERNAL = 'EXTERNAL',
}
